var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{attrs:{"name":_vm.type},on:{"change":_vm.emitFacet}},[_vm._l((_vm.selectItems),function(option){return [_c('option',{key:option.label,domProps:{"value":option.value}},[_vm._v(" "+_vm._s(option.label)+" ")])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }